import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI, SimulationStatus } from '@nexelem/graphne-api';
import { useMemo } from 'react';
import { useConfig } from '@nexelem/config';
import { useIsGanttSimulation } from './GanttSimulationContext';

const NOT_IN_PROGRESS_STATUSES: SimulationStatus[] = ['Applied', 'Error'];

const ERROR_STATUSES: SimulationStatus[] = ['Error'];

type AgregatedSimulationStatus = 'ERROR' | 'IN_PROGRESS' | null;

export const useGetSimulationStatus = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const api = useGraphneAPI();
  const { modules } = useConfig();
  const isSimulationViewEnabled = modules.production.simulationView;
  const isSimulation = useIsGanttSimulation();

  const { data } = useQuery({
    queryKey: ['simulation-status'],
    queryFn: () => api.getGraphneSimulationApplyStatus(),
    refetchInterval: 15 * 1000,
    staleTime: 15 * 1000,
    enabled: isSimulationViewEnabled && enabled,
  });

  const status: AgregatedSimulationStatus = useMemo(() => {
    if (!data?.status) {
      return null;
    }

    if (ERROR_STATUSES.includes(data.status)) {
      return 'ERROR';
    }
    if (!NOT_IN_PROGRESS_STATUSES.includes(data.status)) {
      return 'IN_PROGRESS';
    }

    return null;
  }, [data?.status]);

  return {
    data,
    status,
    disableActions: isSimulation ? false : status === 'IN_PROGRESS',
  };
};
